import templateUrl from 'emun.customer/customer-product-lists.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class CustomerProductListsController {
    constructor($rootScope) { 
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.productLists = new AutoQuery({
            url: 'QueryProductLists.json?retailerId=' + this.customerId,
            orderBy: '-CreatedOn',
            autoLoad: true,
            pageSize: 10
        })
    }
}

let CustomerProductLists = {
    bindings: {
        customerId: '@'
    },
    controller: CustomerProductListsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default CustomerProductLists